import {Container, SmallView, Text1, View} from "../../../../styles/business-components";
import * as S from './styles'
import Image from "../../../../assets/images/business/b_m_cnt11_img1.png";

export const Content11 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <div>
                        <S.Title>
                            Конфиденциальная{'\n'}
                            информация{'\n'}
                            должна оставаться{'\n'}
                            внутренней!
                        </S.Title>
                    </div>
                    <S.ImageBlock>
                        <S.Image src={Image} alt={"image"}/>
                    </S.ImageBlock>
                    <S.Card>
                        <Text1>
                            <span>Безопасность - основной принцип работы компании TeleGuard, поэтому мы гарантируем максимально возможную защиту.</span>
                            <br/>
                            <br/>
                            <span>
                                С помощью защищенного мессенджера TeleGuard секреты компании защищены от посторонних.
                                В случае если сотрудники меняют отдел или покинут вас, важные коммуникационные материалы,
                                включая данные, которыми они обмениваются, остаются под вашим контролем.
                                Ваш бизнес не подвергается риску.
                            </span>
                        </Text1>
                    </S.Card>
                </S.Content>
            </View>
            <SmallView>
                <S.Title>
                    Конфиденциальная информация
                    должна оставаться внутренней!
                </S.Title>
                <S.SmallContent>
                    <S.ImageBlock>
                        <S.Image src={Image} alt={"image"}/>
                        <S.SmallCard>
                            <S.TextBlock>
                                <S.Text>
                                    Безопасность - основной принцип работы компании TeleGuard, поэтому мы гарантируем максимально возможную защиту.
                                </S.Text>
                                <S.Text>
                                    С помощью защищенного мессенджера TeleGuard секреты компании защищены от посторонних.
                                    В случае если сотрудники меняют отдел или покинут вас, важные коммуникационные материалы,
                                    включая данные, которыми они обмениваются, остаются под вашим контролем.
                                    Ваш бизнес не подвергается риску.
                                </S.Text>
                            </S.TextBlock>
                        </S.SmallCard>
                    </S.ImageBlock>
                </S.SmallContent>
            </SmallView>
        </Container>
    )
}